import * as React from 'react';
import {useMemo, useState} from 'react';
import Button from '@mui/material/Button';
import {Autocomplete, Box, Chip, createTheme, IconButton, Stack, TextField, Tooltip} from "@mui/material";
import TypePicker from "./TypePicker";
import getTranslation from "../translations";
import "./elementorFix.css";
import {ThemeProvider} from "@mui/material/styles";
import {plPL} from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import getDictionaryTranslation from "./dictionary";

const customTheme = createTheme(
    {
        // typography: {
        //     fontSize: '.5rem',
        // },
        palette: {
            secondary: {main: "#2077ce"},
            primary: {main: "#2077ce"},
            success: {
                main: "#4caf50",
                contrastText: "#ffffff",
            },
            error: {
                main: "#f44336",
                contrastText: "#ffffff",
            },
            grey: {
                main: "#6b778c",
                contrastText: "#ffffff",
            },
        },
        components: {
            // MuiButton: {
            //     styleOverrides: {
            //         root: {
            //             marginBottom: ".8rem",
            //             textTransform: "none",
            //             // backgroundColor: "red",
            //         },
            //         contained: {
            //             boxShadow: "none",
            //             "&:active": {
            //                 boxShadow: "none",
            //             },
            //         },
            //     },
            // },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        // color: 'black',
                    },
                },
            },
            MuiAutocomplete: {
                styleOverrides: {
                    root: {
                        textTransform: "none",
                    },
                    contained: {
                        boxShadow: "none",
                        "&:active": {
                            boxShadow: "none",
                        },
                    },
                },
            },
        },
    },
    plPL
);

export default function DataGridCustomFilterModule({data, allowedFilterList, handleFilterValues}) {

    const dataValues = useMemo(() => getValuesFromData(data), [data]);
    const filterTypes = useMemo(() => getFilterTypesFromData(data, dataValues), [data, dataValues]);

    const [filteredValuesQuantity, setFilteredValuesQuantity] = useState(data.length)
    const [muiFilterBoxKey, setMuiFilterBoxKey] = useState(1)

    // useEffect((_ => {
    //     document.addEventListener('keypress', function (e) {
    //             if (e.keyCode == 13) {
    //                 // if (e.key === 'Enter') {
    //                 handleSearchButton()
    //             }
    //         }
    //     )
    // }), [])

    function getValuesFromData(data) {
        const uniqueTypes = Object.keys(data[0])
        const searchTypesWithValuesList = []
        uniqueTypes.map(elementName => {
            // return(element)
            const elementValues = [...new Set(data.map(dataElement => {
                if (dataElement[elementName]) {
                    return dataElement[elementName]
                }
            }))].filter(function (x) {
                return x !== undefined;
            })
            if (elementValues.length > 0) {
                searchTypesWithValuesList.push({[elementName]: elementValues})
            }
        })
        return (searchTypesWithValuesList)
    }

    function getFilterTypesFromData(data, dataValues) {
        // console.log(data)
        // console.log(dataValues)
        const uniqueTypes = Object.keys(data[0])
        const filterTypesTemp = [{field: '', displayName: '-', options: [{label: '-', year: '-'}]}]
        let values = []
        uniqueTypes.map(elementName => {
            values = []

            //jezeli uzytkownik jest niezalogowany to jego lista jest okrojona
            if (!allowedFilterList.includes(elementName)) {
                return
            }

            dataValues.filter(item => {
                if (Object.keys(item)[0] === elementName) {
                    values = item[elementName]
                }
            })

            const valuesFormatted = []
            values.map(value => {
                valuesFormatted.push({label: value, year: value})
            })

            const translationPlTemp = getTranslation(elementName, 'pl');
            const translationEnTemp = getTranslation(elementName, 'en');
            const displayNameTemp = translationEnTemp.length > 0 ? translationPlTemp + ` (${translationEnTemp})` : translationPlTemp
            filterTypesTemp.push({
                field: elementName,
                displayName: displayNameTemp,
                options: valuesFormatted
            })
        })
        // console.log(filterTypesTemp)
        return filterTypesTemp
    }

    const defaultFilterInput = [
        {key: 0, type: '', value: '', mode: 'standard',},
    ]
    const [filterInputContainer, setFilterInputContainer] = useState(defaultFilterInput);

    const filterInputContainerArrayLength = filterInputContainer.length
    const lowestKey = findLowestKey(filterInputContainer)

    function findLowestKey(arrayOfObjects) {
        return (Math.min(...arrayOfObjects.map(o => o.key)))
    }

    function findLargestKey(arrayOfObjects) {
        return (Math.max(...arrayOfObjects.map(o => o.key)))
    }

    function handleAddInputContainer() {
        setFilterInputContainer(prevState => {
            return [...prevState, {key: findLargestKey(prevState) + 1, type: '', value: '', mode: 'standard'}]
        })
    }

    function getSearchValues() {
        const uniqueTypes = [...new Set(filterInputContainer.map(item => {
            if (item.type.length > 0) {
                return item.type
            }
        }))].filter(function (x) {
            return x !== undefined;
        })

        const searchTypesWithValuesList = []
        uniqueTypes.map(element => {
            const elementValues = [...new Set(filterInputContainer.map(inputElement => {
                if (inputElement.type === element) {
                    if (inputElement.value.length > 0) {
                        return inputElement.value
                    }
                }
            }))].filter(function (x) {
                return x !== undefined;
            })

            if (elementValues.length > 0) {
                searchTypesWithValuesList.push({[element]: elementValues})
            }
        })

        // console.log(searchTypesWithValuesList)
        return searchTypesWithValuesList
    }

    function filterValues(data, searchValues) {
        const dataFiltered = []
        data.filter(dataElement => {
            if (
                searchValues.every(searchValueElement => {
                    return Object.keys(searchValueElement).some(item => {
                        return searchValueElement[item].some(substring => {
                            if (dataElement[item] === null) return false
                            if (item === 'nr_pkbwl') return dataElement[item].toLowerCase().replace(/[^A-Z0-9]+/ig, " ").includes(substring.toLowerCase().replace(/[^A-Z0-9]+/ig, " "))
                            return dataElement[item].toLowerCase().includes(substring.toLowerCase())
                        })
                    })
                })
            ) {
                dataFiltered.push(dataElement)
            }
        })
        return dataFiltered
    }

    function handleSearchButton() {
        const filteredData = filterValues(data, getSearchValues())
        setFilteredValuesQuantity(filteredData.length)
        handleFilterValues(filteredData)
    }

    function handleTypeChange(event, value, itemKey) {
        setFilterInputContainer(prevState => {
            return (
                prevState.map(item => {
                    if (item.key === itemKey) {
                        if (value === null) {
                            item.type = ''
                        } else {
                            item.type = value.value
                        }
                    }
                    return (item)
                })
            )
        })
    }

    function handleAutocompleteInputChange(event, value, itemKey) {
        setFilterInputContainer(prevState => {
            return (
                prevState.map(item => {
                    if (item.key === itemKey) {
                        if (value != null) {
                            item.value = value.label
                        }
                    }
                    return (item)
                })
            )
        })
    }

    function handleTextFieldInputChange(value, itemKey) {
        setFilterInputContainer(prevState => {
            return (
                prevState.map(item => {
                    if (item.key === itemKey) {
                        if (value.target.value != null) {
                            item.value = value.target.value
                        }
                    }
                    return (item)
                })
            )
        })
    }

    function handleDeleteInputContainer(itemKey) {
        // if array has only one object - reset value instead of deleting
        if (filterInputContainer.length === 1) {
            setFilterInputContainer(prevState => {
                return prevState.filter(item => item.key === itemKey).map(item => {
                    return (
                        {...item, type: '', value: '',}
                    )
                })
            })
            return
        }
        setFilterInputContainer(prevState => {
            return prevState.filter(item => item.key !== itemKey)
        })
    }

    function handleFilterResetButton() {
        setMuiFilterBoxKey(Math.floor(Math.random() * 1111111111111111)) //minuta
        setFilterInputContainer(defaultFilterInput)
        setFilteredValuesQuantity(data.length)
        handleFilterValues(data)
    }

    return (
        <ThemeProvider theme={customTheme}>
            <Box
                key={muiFilterBoxKey}
            >
                {filterInputContainer.map(item => {
                    const currentType = filterTypes.filter(type => type.field === item.type)[0]
                    const currentTypeField = currentType.field
                    let isDisabled = false
                    if (currentTypeField.length < 1) {
                        isDisabled = true;
                    }

                    const filterTypes2 = filterTypes.map((value) => {
                            return {value: value.field, label: value.displayName}
                        }
                    )

                    return (
                        <Stack display={'flex'}
                               direction={'column'}
                               key={item.key}
                               sx={{marginTop: '1rem', marginBottom: '1rem',}}
                        >
                            <Stack
                                display={'flex'}
                                direction={'row'}
                                gap={2}
                                justifyContent={'space-between'}
                                alignItems={'center'}
                                sx={{
                                    marginTop: '1rem',
                                }}
                            >
                                <Autocomplete
                                    id="autocomplete-fix"
                                    key={item.key + 'typeField'}
                                    options={filterTypes2}
                                    sx={{
                                        width: 666,
                                        // color:'red',
                                        border: 'none'
                                    }}
                                    onChange={(event, value) => handleTypeChange(event, value, item.key)}
                                    renderInput={(params) => <TextField
                                        // sx={{color:'red'}}
                                        {...params}
                                        label="SZUKAJ WEDŁUG/SEARCH BY"/>}
                                />

                                <TypePicker fieldKey={item.key} setFilterInputContainer={setFilterInputContainer}
                                            isDisabled={isDisabled}/>

                                {item.mode === 'autocomplete' &&
                                    <Autocomplete
                                        id="autocomplete-fix"
                                        disabled={isDisabled}
                                        key={item.key + item.type}
                                        options={currentType.options}
                                        sx={{
                                            width: '100%',
                                            // marginLeft: '1.9rem',
                                            border: 'none'
                                        }}
                                        onChange={(event, value) => handleAutocompleteInputChange(event, value, item.key)}
                                        renderInput={(params) => <TextField {...params} variant="standard"
                                                                            label="SZUKAJ WEDŁUG/SEARCH BY"
                                        />}
                                    />
                                }

                                {item.mode === 'standard' &&
                                    <TextField
                                        disabled={isDisabled}
                                        id="autocomplete-fix"
                                        label={getDictionaryTranslation('searchInput', item.type)}
                                        variant="standard"
                                        onChange={(value) => handleTextFieldInputChange(value, item.key)}
                                        sx={{
                                            width: '100%',
                                            // marginLeft: '1.9rem',
                                        }}
                                    />}

                                <Stack direction={'row'}
                                       gap={'.8rem'}
                                       justifyContent={'space-between'}
                                    // sx={{border: '1px solid gray',
                                    // borderRadius: '100px',
                                    //     padding: '0 .3rem',
                                    // }}
                                >
                                    <Tooltip title="Dodaj nowy filtr / Add new filter">
                                        <IconButton color="primary"
                                                    onClick={() => handleAddInputContainer(item.key)}>
                                            <AddIcon/>
                                        </IconButton>
                                    </Tooltip>

                                    {filterInputContainerArrayLength === 1 ?
                                        <Tooltip title="Usuń filtr / Delete filter">
                                            <IconButton disabled={true}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </Tooltip>
                                        :
                                        <Tooltip title="Usuń filtr / Delete filter">
                                            <IconButton
                                                color="error"
                                                onClick={() => handleDeleteInputContainer(item.key)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    }

                                </Stack>
                            </Stack>
                        </Stack>
                    )
                })

                }
                <Stack display={'flex'} flexDirection={'row'} gap={'1rem'} alignItems={'center'} justifyContent={'end'}
                       sx={{marginBottom: '.8rem',}}>
                    <Chip label={`WYNIKI/RESULTS: ${filteredValuesQuantity}`}/>
                    <Button
                        onClick={handleFilterResetButton}
                        variant="outlined"
                        sx={{
                            padding: '.8rem',
                        }}
                    >RESETUJ FIlTRY / RESET FILTERS
                    </Button>
                    <Button
                        sx={{
                            padding: '.8rem',
                        }}
                        onClick={() => handleSearchButton()}
                        variant="contained"> SZUKAJ/SEARCH
                    </Button>
                </Stack>
            </Box>
        </ThemeProvider>
    )
}

